import { ReactNode } from 'react';
import { useTable } from './Table';
import { cn } from 'styles';
import { tableStyleConfig } from './styles';

interface TableRowProps {
  children: ReactNode;
  className?: string;
}

function TableRow({ children, className }: TableRowProps): JSX.Element {
  const { rowClassName, rowDivisor } = useTable();

  return (
    <tr className={cn(tableStyleConfig.rowDivisor[rowDivisor], rowClassName, className)}>
      {children}
    </tr>
  );
}

export default TableRow;
